var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-graph-data"},[_c('ReportGraph',{staticClass:"report-graph",attrs:{"chart-data":_vm.datacollection,"barData":_vm.createdBarChart,"streamData":_vm.cameraData,"height":100}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }